export const COMPANY_CONFIG = {
    name: "Global Bizness",
    legalName: "Global Bizness",
    tagline: "Simplified & Secure Digital Payments for Bharat",
    phone: "+91 7793965475",
    phoneClean: "+917793965475",
    email: "Biznesspaysupport@gmail.com",
    address: {
        line1: "Fourth floor, unit number 405 to 4011",
        line2: "House number 1-98/3/5/23 to 27",
        building: "Workflo, Hitex Bizness Square",
        area: "Jubilee Enclave, Madhapur",
        city: "Serilingampally, Hyderabad",
        state: "Telangana",
        pincode: "500081",
        country: "India",
        full: "Fourth floor, unit number 405 to 4011, House number 1-98/3/5/23 to 27, Workflo, Hitex Bizness Square, Jubilee Enclave, Madhapur, Serilingampally, Hyderabad, Telangana - 500081, India",
    },
    operatingHours:
        "Monday to Saturday: 9:00 AM – 8:00 PM IST (Emergency Desk: 24/7)",
    supportTurnaround: "Within 2 to 4 business hours",
    // Explicitly note: No PCI DSS or IIT licence claims as requested by user.
    // Instead, ISO 9001:2015 quality process, 256-Bit SSL bank-grade encryption, BBPS Bharat BillPay ecosystem.
    certifications: [
        "256-Bit Bank Grade SSL Encryption",
        "ISO 9001:2015 Certified Operations",
        "BBPS Bharat BillPay Certified Network",
        "Real-time AI Fraud Monitoring",
    ],
};
